import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-stats-page-container',
  template: '<div><ng-content></ng-content></div>',
  styleUrls: ['./stats-page-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatsPageContainerComponent {}
